// Deprecated

"use strict";

module.exports = function (obj) {
 return typeof obj === "function";
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/is-callable.js
// module id = 198
// module chunks = 0